import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Link from "components/Button/Link";
import Switch from "components/Switch/Switch";
// import { Input } from "components/Form";
// import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import { RemoveRedEye } from "@mui/icons-material";
import toast from "react-hot-toast";
import { getbhaktaparivar } from "services/bhaktaparivar/bhaktaparivar";
import ModalBox from "components/modal/ModalBox";
import * as XLSX from "xlsx";

export default function BhaktaParivar() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [record, setRecord] = useState([{}]);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [allRoles, setAllRoles] = useState([]);
  const [data, setData] = useState({});

  const [statusModal, setStatusModal] = useState(false);

  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [submitButtonElement1, setSubmitLoading1] = useMuiButtonLoader();
  const [deleteModal, setDeleteModal] = useState(false);

  // ************************************** Fetch Records **********************************************

  const downloadHandler = async () => {
    setSubmitLoading1(true);
    try {
      const res = await getbhaktaparivar({
        page: activePage,
        search: search,
        limit: limit,
        type: "excel"
      });

      console.log(res); // Debug log

      if (res.code === 200 && res.data && res.data.followers.rows?.rows) {
        const data = res.data.followers.rows?.rows.map((admission, index) => ({
          "अनु. क्र.": index + 1,
          "नाव": admission.name || "",
          "कुटुंब प्रमुखाचे नाव/ संदर्भित व्यक्ती": admission.refferalname || "-",
          "फोन नंबर": admission.mobile || "",
          "पत्ता": admission.address || "",
          "शहर": admission.city || "",
          "जिल्हा": admission.districtinfo?.districtname || "",
          "राज्य": admission.state || "",
          "आहेर": admission.gifttype || "",
        }));

        console.log(data); // Debug log

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "भक्त परिवार");
        XLSX.writeFile(wb, "BhaktaParivarList.xlsx");
        toast.success("Excel यशस्वीपणे डाउनलोड केले!");
      } else {
        toast.error("नोंदी सापडल्या नाहीत");
      }
    } catch (err) {
      console.error("Error downloading Excel file:", err);
      toast.error("Excel डाउनलोड करताना त्रुटी आली");
    }
    setSubmitLoading1(false);
  };


  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getbhaktaparivar({
        page: activePage,
        search: search,
        limit: limit,
      });
      console.log(res)
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.followers.rows;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.ceil(count / limit));
        } else {
          setPageCount(Math.ceil(count / limit));
        }
        setSelectedId("");
      } else {
        toast.error(res.message);
        setSelectedId("");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    // When search changes, always reset to page 1
    setActivePage(1);
  }, [search]);

  useEffect(() => {
    // Always fetch records when page or search changes
    fetchRecord();
  }, [activePage, search]);


  const toMarathiNumber = (num) => {
    const marathiDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return num
      .toString()
      .split('')
      .map((digit) => (/\d/.test(digit) ? marathiDigits[digit] : digit))
      .join('');
  };

  const restFilter = () => {
    setSearch("");
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="" style={{ width: "50%", alignItems: "right" }}>
                <div className="SearchBox w-100 " style={{ gap: "15px" }}>
                  <div className="col-form-label py-0 col-sm-6">
                    <div className="d-flex align-items-center w-100">
                      <input
                        type="text"
                        placeholder="शोधा"
                        name="search"
                        className="form-control"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ flex: 1 }}
                      />
                      <Button
                        className="refresh_btnn ms-2"
                        onClick={restFilter}
                        title="Reset Filter"
                      >
                        <i className="fa fa-refresh"></i>
                      </Button>
                      <Button
                        className="refresh_btnn ms-2"
                        onClick={downloadHandler}
                        title="Download Excel"
                      >
                        <i className="fa fa-download"></i>
                      </Button>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <Button to={"add-bhakta"}>भक्त परिवार जोडा</Button>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center w-full mt-3" style={{ display: "flex", gap: "15px" }}>
                <h4 className="Title mb-0">भक्त&nbsp;परिवार</h4>
                <h3 className="mb-0">(एकूण नोंदी: {total})</h3>
              </div>
            </div>
            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th style={{ borderRight: "1px solid #fff" }}>अनु.क्र.</th>
                    <th style={{ borderRight: "1px solid #fff" }}>
                      नाव
                    </th>
                    <th style={{ borderRight: "1px solid #fff" }}>
                      कुटुंब प्रमुखाचे नाव/ संदर्भित व्यक्ती
                    </th>
                    <th style={{ borderRight: "1px solid #fff" }}>फोन नंबर</th>
                    {/* <th style={{ borderRight: "1px solid #fff" }}>ईमेल</th> */}
                    <th style={{ borderRight: "1px solid #fff" }}>पत्ता</th>
                    <th style={{ borderRight: "1px solid #fff" }}>शहर</th>
                    <th style={{ borderRight: "1px solid #fff" }}>जिल्हा</th>
                    <th style={{ borderRight: "1px solid #fff" }}>राज्य</th>
                    {/* <th style={{ borderRight: "1px solid #fff" }}>पिनकोड</th> */}
                    {/* <th style={{ borderRight: "1px solid #fff" }}>वय</th> */}
                    <th style={{ borderRight: "1px solid #fff" }}>आहेर</th>
                    <th className="text-center">क्रिया</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          name,
                          mobile,
                          email,
                          address,
                          city,
                          district,
                          state,
                          pincode,
                          age,
                          refferalname,
                          districtinfo,
                          gifttype,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td style={{ width: "50px" }}>
                            {++i + (activePage - 1) * limit}
                          </td>
                          <td>{name}</td>
                          <td>{refferalname || "-"}</td>
                          <td>{mobile}</td>
                          {/* <td>{email}</td> */}
                          <td>{address}</td>
                          <td>{city}</td>
                          <td>{districtinfo?.districtname}</td>
                          <td>{state}</td>
                          {/* <td>{pincode}</td> */}
                          {/* <td>{age}</td> */}
                          <td>{gifttype}</td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`update-bhakta/${id}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
